import { render, staticRenderFns } from "./CardListView.vue?vue&type=template&id=bbe45ec0&scoped=true&"
import script from "./CardListView.vue?vue&type=script&lang=ts&"
export * from "./CardListView.vue?vue&type=script&lang=ts&"
import style0 from "./CardListView.vue?vue&type=style&index=0&id=bbe45ec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe45ec0",
  null
  
)

export default component.exports